export default "__VITE_ASSET__BsVwuvyD__"